module.exports = __webpack_public_path__ + "img/story016@2x.41b6bbc3.png";